<template>
  <div class="courierExamine">
    <div class="formDiv">
      <div class="item">
        <div class="icon ico ico-user"></div>
        <div>{{userinfo.fullname}}</div>
      </div>
      <div class="item">
        <div class="icon ico ico-phone"></div>
        <div>{{userinfo.phone}}</div>
      </div>
      <div class="item">
        <div class="icon ico ico-idCard"></div>
        <div>{{userinfo.idcard}}</div>
      </div>
      <div class="item">
        <div class="icon ico ico-building"></div>
        <div>{{userinfo.company}}</div>
      </div>
    </div>
    <div class="submitBtn">
      <el-button type="primary" @click="refuseFun">拒绝</el-button>
      <el-button type="primary" @click="changeStatus('1')">同意</el-button>
    </div>
    <template v-if="isShow">
      <div class="bg" @click="removeDio"></div>
      <div class="applyDio">
        <div class="cont">
          <el-input type="textarea" :rows="4" placeholder="请输入拒绝理由" v-model="userinfo.refuse"></el-input>
        </div>
        <div class="btnDiv">
          <div class="btn" @click="removeDio">取消</div>
          <div class="btn" @click="changeStatus('-1')">确定</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { showToast } from '../../../../static/js/utility/utility';
import axios from 'axios'
import * as config from '../../../../static/js/config.js';

export default {
  name:'courierExamine',
  data(){
    return {
      userinfo:{
        fullname:'',//姓名
        phone:'',//手机号
        idcard:'',//身份证号
        company:'',//所属快递公司
        refuse:'',//拒绝理由
      },

      isShow:false,//拒绝弹窗
    }
  },
  created(){
    this.getInfo()
  },
  mounted(){

  },
  methods:{
    //获取用户信息
    getInfo(){
      let that = this;
      const dataObj = {
        'info': that.$route.query.info,//公司id
      }
      axios({
        url: config.commonAddress + "/common/Courier/getCourierInfo",
        method: "post",
        data: dataObj,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(function(res) {
        // console.log(res)
        if(res.data.meta.code == 200){
          that.userinfo = {
            fullname:res.data.data.user_name,//姓名
            phone:res.data.data.phone_no,//手机号
            idcard:res.data.data.identity,//身份证号
            company:res.data.data.express_company,//所属快递公司
            refuse:'',//拒绝理由
          }
        }else{
          showToast(res.data.meta.message)
        }
      })

    },
    //弹窗取消
    removeDio(){
      this.isShow = false;
      this.userinfo.refuse = ''
    },
    //修改状态
    changeStatus(type){
      let that = this
      const dataObj = {
        'info': that.$route.query.info,//公司id
        'status':type,//1为同意，-1为拒绝
      }
      if(type == '-1'){
        if(that.userinfo.refuse==''){
          showToast('请填写拒绝理由！')
          return
        }else{
          dataObj.desc = that.userinfo.refuse
        }
      }
      axios({
        url: config.commonAddress + "/common/Courier/updateCourierStatus",
        method: "post",
        data: dataObj,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(function(res) {
        if(res.data.meta.code == 200){
          if(type == '-1'){
            that.userinfo.refuse = ''
            that.isShow = false
          }
          that.$router.push({
            path:'/courierStatus',
            query:{
              type:type=='-1'? '3':'2',//1提交申请，2申请通过，3申请不通过
            }
          })
        }else{
          showToast(res.data.meta.message)
        }
      })
    },
    //点击拒绝
    refuseFun(){
      this.isShow = true
    },
  },
  components:{
    // Field,
  },
  watch:{

  }
}
</script>
<style lang="scss">
.courierExamine{
  background: #f2f2f2;
  height: 100vh;
  padding-top: 0.2rem;
  box-sizing: border-box;
  .applyDio{
    background: #fff;
    width: 80%;
    left: 10%;
    border-radius: 0.06rem;
    position: fixed;
    z-index: 10;
    top: 20%;
    .el-textarea{
      font-size: 0.3rem;
    }
    .btnDiv{
      display: flex;
      border-top: 0.01rem solid #ddd;
      .btn{
        height: 0.8rem;
        line-height: 0.8rem;
        text-align: center;
        width: 50%;
        font-size: 0.3rem;
        box-sizing: border-box;
        border-right: 0.01rem solid #ddd;
        color: #666;
        &:last-child{ border: none; color: #409EFF;}
      }
    }
  }
  .bg{
    position: fixed;
    z-index: 9;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: rgba(0, 0, 0, .5)
  }
  .formDiv{
    border-top: 0.01rem solid #ddd;
    .item{
      background: #fff;
      display: flex;
      align-items: center;
      padding:0.2rem;
      font-size: 0.4rem;
      border-bottom: 0.01rem solid #ddd;
      color: #666;
      .icon{
        color: #666;
        margin-right: 0.2rem;
        font-size: 0.36rem;
      }
    }
  }
  .submitBtn{
    text-align: center;
    margin-top: 1rem;
    .el-button{
      margin: 0 0.2rem;
      font-size: 0.3rem;
      padding: 0.2rem 1rem;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/PhonePage/courierBusiness/courierExamine.vue